export const content = {
  navbar: {
    logo: "",
    links: [
      { label: "HOME", href: "/" },
      { label: "ABOUT US", href: "/about" },
      { label: "IT SERVICES", href: "/it-services" },
      { label: "ENGINEERING SERVICES", href: "/engineering-services" },
      { label: "CAREERS", href: "/careers" },
      // { label: "FOUNDERS", href: "/founders" },
      // { label: "BLOGS", href: "/blogs" },
      // { label: "JOBS", href: "/jobs" },
    ],
    cta: "CONTACT US",
  },
  hero: {
    headingPart1: "Transform Your Business with Custom Software & Engineering Designs",
    // headingHighlightTeal: "WITH SMART",
    // headingPart2: "SCALABLE TECHNOLOGY",
    // headingHighlightPurple: "SOLUTIONS",
    // subheadingStyle1: "Startups",
    // subheadingDesc1: "Reduce your burn and build your vision.",
    // subheadingStyle2: "Businesses",
    // subheadingDesc2: "Cutting-edge software solutions tailored for you.",
    // cta1: "TALK TO US",
    // cta2: "REQUEST A CONSULTATION",


  },
  valueProps: [
    {
      title: "Enterprise-Ready, Built to Scale",
      description: "We don't just build software — we engineer platforms built to scale securely.",
      icon: "Shield",
    },
    {
      title: "Concept to Deployment",
      description: "We handle the technical complexity so you can focus on business outcomes.",
      icon: "Rocket",
    },
    {
      title: "Focused on Outcomes",
      description: "We take care of quality and support, so your team stays focused on growth.",
      icon: "Target",
    },
  ],
  services: {
    title: "Our Services",
    subtitle: "Software, Engineered to Perform — Secure, scalable IT solutions built to grow with your business",
    cta1: "PITCH YOUR IDEA",
    cta2: "REQUEST A CONSULTATION",
    items: [
      {
        title: "Custom Software Development",
        description: "Enterprise-ready software tailored to your business — from SaaS platforms and legacy modernization to AI-driven automation and custom CRM/ERP systems.",
        icon: "Layers",
      },
      {
        title: "Web Development",
        description: "Responsive, secure and scalable websites and web applications engineered to enhance engagement and drive conversions.",
        icon: "Laptop",
      },
      {
        title: "Mobile Application Development",
        description: "Secure, high-performance mobile apps built with Swift, React Native, Flutter and Kotlin — engineered for seamless cross-platform experiences",
        icon: "Smartphone",
      },
      {
        title: "Data Integration & Migration",
        description: "Secure, accurate data migration and ETL solutions that keep your systems synchronized and your data reliable.",
        icon: "Globe",
      },
      {
        title: "Legacy Modernization",
        description: "Transform outdated systems into modern, future-ready infrastructure without disrupting operations.",
        icon: "Cloud",
      },
      {
        title: "Quality Management",
        description: "Rigorous testing and continuous monitoring that keep your software reliable, efficient and bug-free.",
        icon: "BarChart",
      },
      {
        title: "Data Visualization",
        description: "Turn complex data into clear, actionable insights that drive faster, better business decisions.",
        icon: "Rocket",
      },
      {
        title: "Artificial Intelligence",
        description: "AI-powered automation and decision-making tools that streamline operations and keep you ahead of the curve.",
        icon: "BrainCircuit",
      },
      {
        title: "Data Security & Compliance",
        description: "Enterprise-grade security solutions that protect your business and keep you compliant with industry standards.",
        icon: "ShieldCheck",
      },
      {
        title: "Cloud Solutions",
        description: "Secure, scalable cloud infrastructure that improves agility, reduces cost and enables seamless team collaboration.",
        icon: "Cloudy",
      },
      {
        title: "Switch Rack & Server Rack",
        description: "Optimized server and switch rack design and installation for peak system performance and organized infrastructure.",
        icon: "Database",
      },
      {
        title: "Remote Management",
        description: "Proactive IT monitoring and issue resolution that minimizes downtime and maximizes productivity.",
        icon: "LaptopMinimalCheck",
      },
      {
        title: "Network Resource Optimization",
        description: "Smarter bandwidth and load management that keeps your network fast, efficient and reliable.",
        icon: "ArrowDownUp",
      },
    ],
  },
  differentSection: {
    title: "What Makes Us Different",
    description: "Your Partner for Scalable, Secure Growth",
    subDescription: "Whether you need enterprise software, engineering expertise or both, our team is ready to help you scale securely and achieve outcomes you can measure. Let's talk about what we can build together.",
    blocks: [
      {
        title: "Enterprise-Ready by Design",
        description: "Every solution we build is architected for security, scalability and long-term reliability from day one",
        icon: "LucideBuilding",
      },
      {
        title: "Security & Quality First",
        description: "Rigorous, quality-assured processes and compliance-driven security controls run through every engagement.",
        icon: "Box",
      },
      {
        title: "Measurable Business Outcomes",
        description: "We define success in numbers — reduced turnaround, lower operational cost and quantifiable efficiency gains.",
        icon: "Building2",
      },
    ],
  },
  testimonial: {
    sectionTitle: "What Our Client Says",
    quote: "Keel Info Solutions team stepped in as our missing tech team and delivered exactly what we needed. Their involvement not only brought our vision to life but also provided the necessary foundation to attract investors and successfully raise our first round.",
    author: "Alex Ross",
    role: "Founder of Startup X",
    image: "/testimonial-author.jpg",
  },
  howItWorks: {
    title: "How It Works",
    subtitle: "Transformed team support to startups and companies by providing world-class tech expertise.",
    steps: [
      {
        number: "01",
        title: "Match You with a Team of Experts",
        description: "We find the best talent tailored to your specific needs.",
      },
      {
        number: "02",
        title: "Your Pitch, Our Strategy",
        description: "We map out the roadmap to bring your idea to life.",
      },
      {
        number: "03",
        title: "We Build, You Growth",
        description: "Continuous development and scaling support.",
      },
      {
        number: "04",
        title: "You Scale, We Rise",
        description: "Supporting your growth as you reach new milestones.",
      },
    ],
  },
  ctaBox: {
    title: "Let's Build Something Amazing Together",
    subtitle: "Your business needs tech that works, and we're here to provide it.",
    button1: "GET STARTED",
    // button2: "SCHEDULE A CALL",
  },
  caseStudies: {
    title: "Our Case Studies",
    subtitle: "Managed team support to startups and companies by providing world-class tech expertise.",
    items: [
      {
        title: "AI-Powered Analytics Platform",
        category: "Analytics",
        date: "05-2026",
        image: "/case-study-1.jpg",
      },
      {
        title: "Fintech Mobile Wallet Solution",
        category: "Fintech",
        date: "04-2026",
        image: "/case-study-2.jpg",
      },
      {
        title: "Next-Gen E-commerce Engine",
        category: "E-commerce",
        date: "03-2026",
        image: "/case-study-1.jpg", // Fallback for missing generation
      },
    ],
  },
  footer: {
    logo: "",
    slogan: "Empowering businesses with cutting-edge technology solution",
    mission: "Keel Info Solutions supports startups and companies by providing world-class tech expertise.",
    // newsletterTitle: "subscribe to our newsletter for industry insights and company news!",
    // ctaJoin: "WANT TO JOIN US",
    // ctaSend: "SEND NOW",
    columns: [
      {
        title: "Useful Links",
        links: [
          { label: "About Us", href: "/about" },
          { label: "IT Services", href: "/it-services" },
          { label: "Engineering Services", href: "/engineering-services" },
          { label: "Contact Us", href: "/contact" },
          { label: "Privacy Policy", href: "/privacy-policy" }
        ],
      },
      {
        title: "Services",
        links: [
          { label: "Custom Software Development", href: "/it-services" },
          { label: "Web Development", href: "/it-services" },
          { label: "Data Integration & Migration", href: "/it-services" },
          { label: "Legacy Modernization", href: "/it-services" }
        ],
      },
    ],
    locations: [
      {
        title: "Chennai, India (Head Office)",
        phones: [
          "support@keelis.com",
          "+91 4422299222"
        ],
        location: "No. 672, 3rd Floor, Temple Tower\nAnna Salai, Nandanam\nChennai – 600035, India.",
      },
      {
        title: "Riyadh, Saudi Arabia",
        phones: [
          "RiyadhKSA@keelis.com",
          "+966-534688971"
        ],
        location: "",
      }
    ],
    copyright: "© 2026 All Rights Reserved",
  },
  privacyPolicy: {
    title: "Privacy Policy",
    lastUpdated: "31.08.2026",
    intro: "Keel Info Solution (\"Keel Info Solution,\" \"we,\" \"us,\" or \"our\") is committed to protecting the privacy and security of the personal information of visitors to our website (the \"Site\") and users of our services. This Privacy Policy explains how we collect, use, disclose and safeguard your information when you visit our Site or engage with our services.\n\nBy using our Site, you agree to the terms of this Privacy Policy. If you do not agree, please discontinue use of the Site.",
    sections: [
      {
        title: "1. Information We Collect",
        content: "We may collect the following types of information:\n\n**Personal Information You Provide**\nName, email address, phone number and company details submitted through contact forms, inquiry forms or job applications\nInformation provided when requesting a quote, demo or consultation\nCorrespondence you send us\n\n**Automatically Collected Information**\nIP address, browser type, device information and operating system\nPages visited, time spent on the Site and referring URLs\nCookies and similar tracking technologies (see Section 4)\n\n**Information from Third Parties**\nInformation shared by business partners, recruiters or professional networking platforms (e.g. LinkedIn) where you have engaged with us"
      },
      {
        title: "2. How We Use Your Information",
        content: "We use the information we collect to:\n\nRespond to inquiries and provide requested services\nDeliver, maintain and improve our IT and engineering services and products\nCommunicate updates, proposals and marketing materials (where you have consented)\nProcess job applications and recruitment\nAnalyze Site usage to improve user experience\nComply with legal obligations and enforce our terms"
      },
      {
        title: "3. How We Share Your Information",
        content: "We do not sell your personal information. We may share information with:\n\n**Service Providers** — Third parties who support our operations (e.g. hosting, analytics, email delivery), bound by confidentiality obligations\n**Business Partners** — Insurers, vendors or partners involved in delivering a requested service (e.g. Insurelogist-related integrations)\n**Legal & Regulatory Authorities** — Where required to comply with law, regulation or legal process\n**Business Transfers** — In connection with a merger, acquisition or sale of assets"
      },
      {
        title: "4. Cookies & Tracking Technologies",
        content: "Our Site may use cookies and similar technologies to enhance functionality, analyze traffic and personalize content. You can control cookie preferences through your browser settings. Disabling cookies may affect certain features of the Site."
      },
      {
        title: "5. Data Security",
        content: "We implement industry-standard technical and organizational security measures — including encryption, access controls and regular security assessments — to protect your information from unauthorized access, disclosure, alteration or destruction. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security."
      },
      {
        title: "6. Data Retention",
        content: "We retain personal information only for as long as necessary to fulfill the purposes outlined in this Policy, comply with legal obligations, resolve disputes and enforce our agreements."
      },
      {
        title: "7. Your Rights",
        content: "Depending on your jurisdiction, you may have the right to:\n\nAccess, correct or delete your personal information\nObject to or restrict certain processing\nWithdraw consent for marketing communications at any time\nRequest a copy of your data in a portable format\n\nTo exercise these rights, contact us using the details in Section 10."
      },
      {
        title: "8. Third-Party Links",
        content: "Our Site may contain links to third-party websites. We are not responsible for the privacy practices or content of those external sites and encourage you to review their privacy policies."
      },
      {
        title: "9. Children's Privacy",
        content: "Our Site and services are intended for business use and are not directed at individuals under the age of 18. We do not knowingly collect personal information from children."
      },
      {
        title: "10. Contact Us",
        content: "If you have questions or concerns about this Privacy Policy or how we handle your information, please contact us at:\n\nKeel Info Solution\nEmail: support@keelis.com\nAddress: No. 672, 3rd Floor, Temple Tower Anna Salai, Nandanam Chennai – 600035, India."
      },
      {
        title: "11. Changes to This Policy",
        content: "We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. The updated version will be posted on this page with a revised \"Last Updated\" date. Continued use of the Site after changes constitutes acceptance of the updated Policy."
      }
    ]
  }
};
